@if (cartItems$ | async; as cartItems) {
  <section class="cart">
    <ng-template #feeHeader let-title="title" let-showSubtitle="showSubtitle">
      <se-fe-header
        class="cart__fee-header"
        [seFeDataTitle]="title"
        [seFeDataSubtitle]="showSubtitle ? 'if paid in full upfront' : ''"
        seFeDataSize="tableRow"></se-fe-header>
    </ng-template>
    <section class="cart__top-header">
      <h3 class="cart__subtotal-title">
        Subtotal ({{ 1 + cartItems.length | i18nPlural: cartMessageMapping }})
      </h3>
      @if (context$ | async; as contextData) {
        <ng-container
          *ngTemplateOutlet="
            feeHeader;
            context: {
              title: (cartSubtotal$ | async | currency),
              showSubtitle:
                contextData.signups[0].requestDetails.customerPaysFee,
            }
          "></ng-container>
      }
    </section>
    <hr />
    @if (cartItems.length > 0) {
      <div class="cart__optional-items">
        @for (cartItem of cartItems; track cartItem.id) {
          <app-cart-item [item]="cartItem"></app-cart-item>
        }
      </div>
    }
    <section class="cart__required-items">
      <h3 class="cart__title">Required Items</h3>
      <span class="cart__subtitle">
        These items are required to participate in this program. You cannot
        modify them or remove them from the cart.
      </span>
      @if (context$ | async; as contextData) {
        <se-fe-card [seFeDataFullHeight]="true" class="cart__required">
          <se-fe-card-content
            class="cart__required-content"
            [seFeDataFullHeight]="true">
            <se-fe-avatar
              class="cart__required-logo"
              seFeDataType="org"
              [seFeDataIdentity]="contextData.bossOrganization.name"
              [seFeDataImgUrl]="contextData.bossOrganization.orgLogo"
              seFeDataSize="300"></se-fe-avatar>
            <div class="cart__required-text">
              <div class="cart__required-info">
                <span class="cart__required-title">
                  {{ contextData.bossOrganization.name }}
                </span>
                <span class="cart__required-subtitle">
                  {{ requiredItemSubtitle(contextData) }}
                </span>
              </div>
              <ng-container
                *ngTemplateOutlet="
                  feeHeader;
                  context: {
                    title:
                      (contextData.signups[0].requestDetails.eventCost
                      | currency),
                    showSubtitle:
                      contextData.signups[0].requestDetails.customerPaysFee,
                  }
                "></ng-container>
            </div>
          </se-fe-card-content>
        </se-fe-card>
      }
    </section>
    <hr />
    <section class="cart__order-summary">
      <h2 class="cart__order-summary-title">Order Summary</h2>
      <div class="cart__order-summary-items">
        <span>
          Items Total ({{
            1 + cartItems.length | i18nPlural: cartMessageMapping
          }})
        </span>
        <span class="cart__order-summary-prices">
          {{ cartSubtotal$ | async | currency }}
        </span>
      </div>
      <hr />
      <section class="cart__top-header">
        <h3 class="cart__subtotal-title">
          Subtotal ({{ 1 + cartItems.length | i18nPlural: cartMessageMapping }})
        </h3>
        @if (context$ | async; as contextData) {
          <ng-container
            *ngTemplateOutlet="
              feeHeader;
              context: {
                title: (cartSubtotal$ | async | currency),
                showSubtitle:
                  contextData.signups[0].requestDetails.customerPaysFee,
              }
            "></ng-container>
        }
      </section>
    </section>
    <hr />
    @if (!useProjection) {
      <div class="cart__buttons">
        <se-fe-button
          seFeDataEmphasis="medium"
          [seFeDataFullWidth]="true"
          (click)="closeCartSlide()">
          Close Shopping Cart
        </se-fe-button>
        <se-fe-button
          seFeDataEmphasis="medium"
          [seFeDataFullWidth]="true"
          (click)="nextStep()">
          Continue to next step
        </se-fe-button>
      </div>
    } @else {
      <div class="cart__buttons">
        <ng-content></ng-content>
      </div>
    }
  </section>
}
